import { collections } from "@/mocks/home";

type CollectionsProps = {
  onNotify: (message: string) => void;
};

export default function Collections({ onNotify }: CollectionsProps) {
  return (
    <section id="collections" className="w-full bg-background-50 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <div className="max-w-xl">
          <span className="font-label text-xs tracking-[0.3em] text-primary-600">COLLECTIONS</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            专题合集
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            把分散的热帖按主题归拢成合集，每个专题都整理好时间线与关键节点，适合快速补齐进度。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:mt-14 md:grid-cols-2 md:gap-6">
          {collections.map((item) => (
            <article
              key={item.id}
              className="group cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-100/60 transition-transform duration-300 hover:-translate-y-1.5"
              onClick={() => onNotify(`「${item.title}」为静态展示，正式版可直接进入合集`)}
            >
              <div className="h-48 w-full overflow-hidden md:h-60">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} 专题合集`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2 flex-wrap">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-md bg-background-50 px-2.5 py-1 text-xs text-foreground-600"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="mt-4 font-heading text-xl font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">
                  {item.subtitle}
                </p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="font-label text-sm text-foreground-500">
                    共 <strong className="text-foreground-900">{item.count}</strong> 条内容
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600">
                    查看合集
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}